import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    businessProcess: {},
    loaded: false,
    bpId: 0,
    updateMessage: ""
  }
};
const businessProcessItemSlice = createSlice({
  name: "businessProcessItem",
  initialState,
  reducers: {
    loadOneBusinessProcess: (state, action) => {
      state.value = {
        businessProcess: action.payload,
        loaded: true,
        bpId: action.payload.bpId,
        updateMessage: "success"
      };
    },
    clearBp: (state) => {
      state.value = {
        businessProcess: {},
        loaded: false,
        bpId: 0,
        updateMessage: ""
      };
    },
    updateBusinessProcess: (state, action) => {
      if (action.payload.message === "success") {
        state.value = {
          businessProcess: action.payload.item,
          loaded: true,
          bpId: action.payload.item.orgUnitId,
          updateMessage: "success"
        };
      } else {
        state.value = {
          businessProcess: action.payload.item,
          loaded: true,
          bpId: action.payload.item.orgUnitId,
          updateMessage: "success"
        };
      }
    }
  }
});
export const { loadOneBusinessProcess, updateBusinessProcess, clearBp } = businessProcessItemSlice.actions;
export default businessProcessItemSlice.reducer;
